import React from "react";
import { BasicRoute } from "components/elements/AppRouter";
import Layout from "components/layouts/Layout";
import { PAGES } from "constants/app";
import EventsPage from "pages/events";
import EventDetails from "pages/events/page/event-details";
import HomePage from "pages/home/page";
import ProductsPage from "pages/products";
import HistoryPage from "pages/history";
import RecruitmentPage from "pages/recruitment";
import Gen8RecruitmentPage from "pages/recruitment/seasons/gen8";

const HistoryDetailPage = React.lazy(() => import("pages/history/detail"));

export const routes: BasicRoute[] = [
  {
    path: PAGES.HOME,
    component: Layout,
    exact: false,
    routes: [
      {
        path: PAGES.HOME,
        label: "HOME",
        component: HomePage,
        exact: true,
        class: "google.yellow",
      },
      {
        path: PAGES.EVENTS_PAGE,
        label: "EVENTS",
        component: EventsPage,
        exact: true,
        class: "google.blue",
      },
      { path: PAGES.EVENTS_PAGE_DETAILS, component: EventDetails, exact: true },
      {
        path: PAGES.PRODUCTS_PAGE,
        label: "PRODUCTS",
        component: ProductsPage,
        exact: true,
        class: "google.red",
      },
      {
        path: PAGES.HISTORY_PAGE,
        label: "HISTORY",
        component: HistoryPage,
        exact: true,
        class: "google.green",
      },
      {
        path: PAGES.HISTORY_PAGE_DETAILS,
        component: HistoryDetailPage,
        exact: true,
      },
      {
        path: PAGES.RECRUITMENT,
        component: RecruitmentPage,
        exact: true,
      },
      {
        path: PAGES.GEN8_RECRUITMENT,
        label: "GEN 8 RECRUITMENT",
        badge: "CLOSED",
        component: Gen8RecruitmentPage,
        exact: true,
        class: "google.yellow",
      },

      // {
      //   path: PAGES.CONTACT_PAGE,
      //   label: "Contact",
      //   component: ContactPage,
      //   exact: true,
      //   class: "google.green",
      // },
    ],
  },
];
